/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.

==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import AutoLogin from '@/middleware/autoLogin.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: AutoLogin,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },
        {
          path: '/pages/user-settings',
          name: 'page-user-settings',
          component: () => import('@/views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/manage-users',
          name: 'manage-system',
          component: () => import('@/views/pages/manage-system/ManageUsers.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage User', active: true }
            ],
            pageTitle: 'Manage User',
            rule: 'editor'
          }
        },
        {
          path: '/pages/companies',
          name: 'tenants-home',
          component: () => import('@/views/pages/tenants/TenantHome.vue'),
          children: [
            {
              path: '',
              name: 'tenants-list',
              component: () => import('@/views/pages/tenants/TenantList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                ],
                pageTitle: 'Manage Companies',
                rule: 'editor'
              }
            },
            {
              path: ':id',
              name: 'tenants-details-tab',
              component: () => import('@/views/pages/tenants/TenantDetailsTabs'),
              meta: {
                parent: 'tenants-list',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Companies', url: '/pages/companies' },
                  { title: 'Company Details', active: true }
                ],
                pageTitle: 'Company Details',
              }
            },
          ]
        },
        {
          path: '/pages/property-assessment',
          name: 'property-assessment',
          component: () => import('@/views/pages/tenants/PropertyRiskAssessmentList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Property Risk Assessment',
            rule: 'editor'
          }
        },
        {
          path: '/pages/food-safety-report',
          name: 'food-safety-report',
          component: () => import('@/views/pages/tenants/FoodSafetyReportList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Food Safety Report',
            rule: 'editor'
          }
        },
        {
          path: '/pages/cope-assessment',
          name: 'property-assessment',
          component: () => import('@/views/pages/tenants/CopeAssessmentList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'COPE Assessment',
            rule: 'editor'
          }
        },
        {
          path: '/pages/hazard-inspection',
          name: 'hazard-inspection',
          component: () => import('@/views/pages/tenants/HazardInspectionList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Hazards Inspection',
            rule: 'editor'
          }
        },
        {
          path: '/pages/brewery-site-inspection',
          name: 'brewery-site-inspection',
          component: () => import('@/views/pages/tenants/BrewerySiteInspectionList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Brewery Site Inspections',
            rule: 'editor'
          }
        },
        {
          path: '/pages/contacts',
          name: 'contacts',
          component: () => import('@/views/pages/tenants/tabs/TenantContacts.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Contacts',
            rule: 'editor'
          }
        },
        {
          path: '/pages/locations',
          name: 'contacts',
          component: () => import('@/views/pages/tenants/tabs/TenantLocations.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Locations',
            rule: 'editor'
          }
        },
        {
          path: '/pages/buildings',
          name: 'contacts',
          component: () => import('@/views/pages/tenants/tabs/TenantBuildings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Buildings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/actions',
          name: 'actions',
          component: () => import('@/views/pages/tenants/tabs/TenantActions.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Action List', active: true }
            ],
            pageTitle: 'Actions',
            rule: 'editor'
          }
        },
        {
          path: '/pages/actions/:id',
          name: 'action-view',
          component: () => import('@/views/pages/tenants/tabs/actions/ActionHome.vue'),
          meta: {
            parent: 'actions-list',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Actions', url: '/pages/actions' },
              { title: 'Action View', active: true }
            ],
            pageTitle: 'Action View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sf-data',
          name: 'sf-data',
          component: () => import('@/views/pages/ai-engine/TestAiEngine.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'SF DATA',
            rule: 'editor'
          }
        },
        {
          path: '/pages/standard-actions',
          name: 'standard-actions',
          component: () => import('@/views/pages/tenants/StandardActionList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
            ],
            pageTitle: 'Standard Actions',
            rule: 'editor'
          }
        },
        {
          path: '/pages/report-templates',
          name: 'manage-report-templates',
          component: () => import('@/views/pages/report-templates/ReportTemplateList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage Report Templates', active: true }
            ],
            pageTitle: 'Manage Report Templates',
            rule: 'editor'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      redirect: '/page/login',
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          beforeEnter: AutoLogin,
        },
        {
          path: '/redirect',
          name: 'redirect',
          component: () => import('@/views/Page2.vue')
        },
        {
          path: '/pages/email-verification/:code',
          name: 'page-verification',
          component: () => import('@/views/pages/EmailVerification.vue')
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
        {
          path: '/pages/reset-password/:token',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  const activePopup = document.getElementById('popup')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
  if (activePopup) {
    activePopup.style.display = 'none'
  }
})

export default router
